// extracted by mini-css-extract-plugin
export var footerGradient = "footer-module--footer-gradient--3NHGZ";
export var linkItem = "footer-module--link-item--3dS2_";
export var lineBreak = "footer-module--line-break--3ed_8";